import { MutationCache, QueryClient } from "@tanstack/react-query";

/** Every failed mutation is a Shopify toast; a page never renders `mutation.error` itself. */
export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
  mutationCache: new MutationCache({
    onError: (error) => shopify.toast.show(error.message, { isError: true }),
  }),
});
